import {
    OPEN_MENU,
    CLOSE_MENU,
    SELECT_TAB,
    SELECT_GENDER,
    CONTENT_ROUTE,
    OPEN_ACCOUNT_MENU,
    CLOSE_ACCOUNT_MENU,
    CLOSE_MOBILE_MENU,
    TOGGLE_MOBILE_MENU
} from '../actions'

const initialState = {
    selectedTab: 'women',
    open: false,
    category: null,
    accountMenuOpen: false,
    mobileMenuOpen: false
}

const menu = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_MENU:
            return {
                ...state,
                open: true,
                accountMenuOpen: false,
                category: action.payload.category
            }
        case CLOSE_MENU:
        case CONTENT_ROUTE:
            return {
                ...state,
                accountMenuOpen: false,
                open: false,
            }
        case OPEN_ACCOUNT_MENU:
            return {
                ...state,
                open: false,
                accountMenuOpen: true,
            }
        case CLOSE_ACCOUNT_MENU:
            return {
                ...state,
                accountMenuOpen: false,
            }
        case SELECT_TAB:
        case SELECT_GENDER:
            return {
                ...state,
                selectedTab: action.payload.tab,
            }
        case CLOSE_MOBILE_MENU:
            return {
                ...state,
                mobileMenuOpen: false,
            }
        case TOGGLE_MOBILE_MENU:
            return {
                ...state,
                mobileMenuOpen: !state.mobileMenuOpen,
            }
        default:
            return state
    }
}

export default menu



// WEBPACK FOOTER //
// ./src/reducers/universal-menu.js